import React, { useState } from 'react';

import { Container, Box, ButtonGroup, Stack, Paper, Button, Tooltip, IconButton, Snackbar } from '@mui/material';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
// import 'prismjs/components/prism-javascript';
// import 'prismjs/themes/prism.css'; //Example style, you can use another
import Service from '../../../../util/Service';
import VeryEditor2 from '../../../common/EditorVery/VeryEditor2';
import { Save } from '@mui/icons-material';

// export default function UserTaskFormHTML(props) {
const UserTaskFormHTML = React.forwardRef((props, ref) => {
    // const { setCards, cards, onClose } = props;
    const { item, processo, onClose, code } = props;
    const refCode = React.useRef();
    const [openSnack, setOpenSnack] = React.useState(false);

    const [html, setHtml] = useState(code?code:`
<html>
<body>

</body>
</html>
    `);

  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnack(false);
  };


    React.useImperativeHandle(ref, ()=> ({
        childMethod() {
            handleSalva();
          }
    }))

    const handleChange=(code)=>{
        setHtml(code)
    }
    const handleSalva =()=>{
        const html = refCode.current.getHtml();
        const dado = {
            idTask: item.id,
            idProcesso: processo.id,
            taskType: item.type,
            html: html
        }        
        
        Service.POST('/api/bpmn/salvarTaskDoProcesso', dado).then(resp => {
            setOpenSnack(true);
            // setWait(false);
            // onClose();
        }).catch(error => {
            console.error(error)
            // setWait(false);
            // setMensagem(error ? error : 'Oops! Something went wrong. Please try again!');
        })
    }

    return (
        <React.Fragment>
            <VeryEditor2 html={html} 
                ref={refCode}
                action={
                    <React.Fragment>
                        <Tooltip title="Salvar pagina">
                            <IconButton aria-label="edit" color="primary"
                                onClick={handleSalva}
                            >
                                <Save />
                            </IconButton>
                        </Tooltip>
                    </React.Fragment>
                }
            />
            <Snackbar
                open={openSnack}
                autoHideDuration={6000}
                onClose={handleCloseSnack}
                message="Registro salvo"                
                />
        </React.Fragment>
    )
    
    return(
        <Container maxWidth="md" sx={{marginTop: 1}}>
            <Paper variant="outlined">
            <Editor 
                value={html}
                onValueChange={handleChange}
                highlight={code => highlight(code, languages.js)}
                padding={10}
                style={{
                    height:'400px', width: "800px",
                    fontFamily: '"Fira code", "Fira Mono", monospace',
                    fontSize: 12,
                }}
            />
            </Paper>
            <Stack>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        '& > *': {
                            m: 1,
                        },
                    }}
                >
                    {/* <ButtonGroup variant="outlined" aria-label="text button group">
                        <Button color='inherit' onClick={()=>handleSalva()}>Salvar</Button>                        
                        <Button color='inherit' onClick={ () => { console.log('x'); onClose() }}>Sair</Button>
                    </ButtonGroup> */}
                </Box>
            </Stack>

            
        </Container>
    )
})
export default UserTaskFormHTML;